<template>
  <div class="display-wrapper fullscreen-wrapper" v-loading="fullscreenLoading">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color:#101129">
      <div class="display-content" v-if="toReload">
        <div class="column left">
          <!-- 培训班统计 -->
          <div class="row class-all" style="height:240px">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title" >讲师简介</div>
              <div class="data-wrapper" style="position: relative">
                <div class="select-wrapper" style="position: absolute;top: -25px;right: -6px;z-index: 999; width: 120px">
                  <el-select v-model="selectCoachIndex" @change="coachChange" style="width: 100%;height: 100%;background-color: rgba(0,0,0,0)">
                    <el-option
                      v-for="item in coachList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem">
                    <img :src="!teacherInfo.profile_picture ? userImg : teacherInfo.profile_picture"
                      @error="imgError" style="width:120px;height:168px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p><span style="color: #FAC858;">{{teacherInfo.name}}（{{teacherInfo.gender}}）</span>   <span style="margin-left:2rem">年龄：50岁</span> </p>
                    <p>注册足协：{{teacherInfo.work_unit || '--'}} </p>
                    <p>讲师等级：<span v-if="teacherInfo.teacher_level !=='--'">{{teacherInfo.teacher_level}}&nbsp;&nbsp;</span>
                      <span v-if="teacherInfo.teacher_level_g !=='--'">{{teacherInfo.teacher_level_g}}&nbsp;&nbsp;</span>
                      <span v-if="teacherInfo.teacher_level_physical !=='--'">{{teacherInfo.teacher_level_physical}}</span>
                    </p>
                    <p>教练员等级：<span v-if="teacherInfo.rankLevel">{{ teacherInfo.rankLevel| level }}&nbsp;&nbsp;</span>
                      <span v-if="teacherInfo.coachRankSpecialType">{{ teacherInfo.coachRankSpecialType| level }} &nbsp;&nbsp;</span>
                      <span v-if="teacherInfo.coachRankPhysicalType">{{ teacherInfo.coachRankPhysicalType| level }}</span>
                    </p>
                    <p>培训班数量：{{teacherInfo.class_num}}个</p>
                    <p>培训学员人次：{{teacherInfo.student_num}}人</p>
                    <p title="延边足协2024年第2期中国足协D级教练员培训班 (长春市)" v-if="teacherInfo.training === '培训中'">培训状态：<span style="color: #FAC858;">培训中（{{teacherInfo.training_time_start | time(false) }}至{{teacherInfo.training_time_end | time(false)}}）</span> </p>
                    <p v-else>培训状态：<span style="color: #FAC858;">空闲</span></p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <!-- 讲师培训状态滚动-->
          <div class="row class-all tutorial-add class-table">
            <div class="row-content">
              <div class="row-title">
                <span style="margin-left:10px">进行中的培训班</span>
              </div>
              <div class="table-wrapper">
                <div class="table-head">
                  <div class="table-column" style="flex: 0.5">讲师</div>
                  <div class="table-column" style="flex: 1.3">培训班</div>
                  <div class="table-column" style="flex: 1.2">培训时间</div>
                </div>
                <div class="table-content">
                  <div class="animation-wrapper" v-if="classData.length > 0">
                    <div class="table-row" v-for="(item,index) in classData" :key="'up' + index">
                      <div class="table-col" style="flex: 0.5;" :title="item.name">{{ item.name }}</div>
                      <div class="table-col" style="flex: 1.3;" :title="item.class_name">{{ item.class_name }}
                      </div>
                      <div class="table-col" style="flex: 1.2;">{{item.start_date | time(false) }} 至 {{item.end_date | time(false) }}
                      </div>
                      
                    </div>
                    <!-- 为了动画问题 -->
                    <div class="table-row" v-for="(item,index) in classData" :key="'down' + index">
                      <div class="table-col" style="flex: 0.5;" :title="item.name">{{ item.name }}</div>
                      <div class="table-col" style="flex: 1.3;" :title="item.class_name">{{ item.class_name }}
                      </div>
                      <div class="table-col" style="flex: 1.2;">{{item.start_date | time(false) }} 至 {{item.end_date | time(false) }}
                      </div>
                    </div>
                  </div>
                  <div class="" v-else>
                    <yioks-empty h="233px"></yioks-empty>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column center">
          <div style="width: 100%; display: flex; justify-content: center; align-items: center;position: absolute;top: -30px;left: 0" >
                            <span @click="toggleApi">
                                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                                <span class="fullscreen-btn" v-else>退出全屏</span>
                            </span>
          </div>
          <!-- 培训班统计 -->
          <div class="row class-all" style="height: 502px;">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">等级讲师统计
                <span class="title" style="color: #FAC858; margin-left: 2rem">总数量： {{numStatisticalAll}}（男：{{numStatisticalSex['男']}}；女：{{numStatisticalSex['女']}}）</span>
              </div>
              <div class="data-wrapper" style="display:block;">
                <div style="display:flex">
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['职业级']}}</div>
                    <div class="data-title">职业级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['A级']}}</div>
                    <div class="data-title">A级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['B级']}}</div>
                    <div class="data-title">B级</div>
                  </div>
                </div>
                <div style="display:flex;margin-top:5px">
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['C级']}}</div>
                    <div class="data-title">C级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['D级']}}</div>
                    <div class="data-title">D级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatistical['D级助理']}}</div>
                    <div class="data-title">D级助理</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-content" style="padding: 1.25rem ;margin-top: 215px">
              <div class="row-title">体能讲师统计
                <span class="title" style="color: #FAC858; margin-left: 2rem">总数量： {{numStatisticalAllPhysical}}（男：{{numStatisticalSex['男_体']}}；女：{{numStatisticalSex['女_体']}}）</span>
              </div>
              <div class="data-wrapper" style="display:block;">
                <div style="display:flex;">
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalPhysical['体能L2级']}}</div>
                    <div class="data-title">体能L2级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalPhysical['体能L1级']}}</div>
                    <div class="data-title">体能L1级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalPhysical['体能L1级助理']}}</div>
                    <div class="data-title">体能L1级助理</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-content" style="padding: 1.25rem ;margin-top: 360px">
              <div class="row-title">守门员讲师统计
                <span class="title" style="color: #FAC858; margin-left: 2rem">总数量： {{numStatisticalAllG}}（男：{{numStatisticalSex['男_守']}}；女：{{numStatisticalSex['女_守']}}）</span>
              </div>
              <div class="data-wrapper" style="display:block;">
                <div style="display:flex">
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalG['守门员A级']}}</div>
                    <div class="data-title">守门员A级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalG['守门员B级']}}</div>
                    <div class="data-title">守门员B级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalG['守门员C级']}}</div>
                    <div class="data-title">守门员C级</div>
                  </div>
                  <div class="data-item">
                    <div class="data num_data">{{numStatisticalG['守门员C级助理']}}</div>
                    <div class="data-title">守门员C级助理</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column right">
          <div class="row tutorial-all class-all class-vip">
            <div class="row-content">
              <div class="row-title">学历统计</div>
              <div class="data-wrapper">
                <div class="echart-class-status" id="echart-class-status"></div>
              </div>
            </div>
          </div>
          <div class="row class-all tutorial-add">
            <div class="row-content">
              <div class="row-title">
                <span>等级讲师性别分布</span>
              </div>
              <div class="data-wrapper">
                <div class="echart-tutorial-add" id="echart-tutorial-add"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="display-content" v-if="toReload" style="background:none;padding:0 0.8rem">
        <div class="column" style="flex:1.5">
          <!-- 运动经历统计 -->
          <div class="row class-all play-vip">
            <div class="row-content">
              <div class="row-title">
                <span>运动经历统计</span>
              </div>
              <div class="echart-class-status" id="echart-play-status"></div>
            </div>
          </div>
        </div>
        <div class="column" style="margin: 0 0 0 1.5rem">
          <div class="row class-all user-all" style="flex:1;">
            <div class="row-content">
              <div class="flex-box" style="width: 100%;height: 100%">
                <div class="flex-item left">
                  <div class="row-title">
                    <span>会员协会讲师统计</span>
                  </div>
                  <div class="data-wrapper">
                    <div class="echart-associate-all" id="echart-associate-all"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fullscreen>
  </div>
</template>

<script>
  import echarts from 'echarts';
  import {nameMap} from "./mapJSON/nameMap";
  // import 'echarts/map/js/china';
  import 'echarts/extension/bmap/bmap';
  import {debounce} from '../../assets/js/utils';
  import {
    getDisplayClassTable,
    getUserLoginData,
    getTeachersData,
    getTeachersVitaeData,
    getTeachersVitaeDataInfo
  } from '../../api/display';
  import VueFullscreen from 'vue-fullscreen'
  import Vue from 'vue'
  import { LevelFilters} from "@/assets/js/status";
  import userImg from "@/assets/images/person.png";
  Vue.use(VueFullscreen);
  
  var moment = require('moment');
  
  export default {
    name:"Display",
    created(){
      this.year = new Date().getFullYear();
    },
    computed:{
      numStatisticalAll(){
        let allCounts = 0;
        for(let key in this.numStatistical){
          allCounts += this.numStatistical[key]
        }
        return allCounts
      },
      numStatisticalAllG(){
        let allCounts = 0;
        for(let key in this.numStatisticalG){
          allCounts += this.numStatisticalG[key]
        }
        return allCounts
      },
      numStatisticalAllPhysical(){
        let allCounts = 0;
        for(let key in this.numStatisticalPhysical){
          allCounts += this.numStatisticalPhysical[key]
        }
        return allCounts
      },
      
    },
    
    watch:{},
    components:{
      "yioks-empty": () => import("@/components/Tips/Empty"),
    },
    data(){
      return {
        userImg,
        fullscreenLoading:false,
        fullscreen:false,
        teleport:true, //
        isFullscreen:false,
        userLoginTimer:null,   // 自动切换定时器
        clickTimer:null, //  点击定时器
        tutorialTimer:null,
        count:0,
        echartsList:[],
        toReload:true,
        year:'',
        numStatistical:{}, // 等级培训数据
        numStatisticalG:{}, // 等级培训数据
        numStatisticalPhysical:{}, // 等级培训数据
        numStatisticalSex:{}, // 等级培训数据
        classNav:0,
        
        classData:[],  // 培训班
        vipClassEchartsData:{},
        vipPlayEchartsData:{},
        vipXueliData:{},
        echartsBarYData:{},
        echartsBarX:[],
        coachList:[],
        
        loginInfoCount:{}, // 用户登录数量统计 原始数据
        coachCount:{}, // 教练员成绩数据，包括，职业，A,B,C,D级通过人数，未通过人数，总人数；
        userCount:{}, // 会员协会用户量统计
        allCoachName:0, // 会员协会用户量统计
        allCoachNamezhuanxiang:0, // 守门员数量
        allCoachNamePhysical:0, // 体能数量
        loginEchartData:{
          xAxisData:[],
          seriesData:[]
        }, // 用户登录数量统计 处理之后的数据
        userInfoOrganization:{},    // 会员协会图表统计 原始数据
        vipUserCountEchartData:{xAxisData:[], seriesData:[]}, // 会员协会图表统计 处理数据
        selectCoachIndex:'',    // 会员协会培训班统计默认培训班选择
        coachAutoChangeTimer:null, // 会员协会默认切换
        changeTimer:null,
        tableTimer:null,   // 培训班监控定时器
        teacherInfo:{},
        // 纵向柱状图配置
        barEchartOption:{
          // title: {
          //     text: '',
          //     subtext: ''
          // },
          xAxis:{
            data:[],
            axisLabel:{
              inside:false,  // 横轴图例文字位置（true在bar上）
              textStyle:{
                color:'#61a8ff'
              },
              interval: 0,
              rotate: -70
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#61a8ff',
                width:1,
                type:'solid'
              }
            },
            axisTick:{
              show:true
            },
            z:10
          },
          yAxis:[
            {
              type:'value'
            }
          ],
          dataZoom:[
            {
              type:'inside'
            }
          ],
          series:[
            {
              type:'bar',
              // itemStyle: {
              //     color: new echarts.graphic.LinearGradient(
              //         0, 0, 0, 1,
              //         [
              //             { offset: 0, color: '#00fffb' }, // 0 起始颜色
              //             { offset: 1, color: '#0061ce' }  // 1 结束颜色
              //         ]
              //     )
              // },
              emphasis:{
                itemStyle:{
                  color:new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#2378f7'},
                      {offset:0.7, color:'#2378f7'},
                      {offset:1, color:'#83bff6'}
                    ]
                  )
                }
              },
              data:[],
            }
          ]
        },
        
        // 多Y轴echar统一配置信息
        doubleYaxisEcharts:{
          color:['#68d8fe', '#91CC75', '#EE6666'],
          // 提示线
          tooltip:{
            trigger:'axis',
            // formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}%',
            formatter:function(params){
              let str = '';
              params.forEach((item, idx) => {
                str += `${item.marker}${item.seriesName}: ${item.data}`
                switch(idx){
                  case 0:
                    str += '人';
                    break;
                  case 1:
                    str += '人';
                    break;
                  case 2:
                    str += '人';
                    break;
                  default:
                    str += ''
                }
                str += idx === params.length - 1 ? '' : '<br/>';
                if(!idx){
                  str = (item.name + '<br/>') + str;
                }
              });
              return str;
            },
            axisPointer:{
              type:'cross'
            }
          },
          // 位置
          grid:{
            right:'8%',
            left:'8%',
            height:"65%",
            width:"85%"
          },
          legend:{
            data:['男', '女', '共'],
            textStyle:{
              color:'#61a8ff'
            }
          },
          xAxis:[
            {
              type:'category',
              axisTick:{
                alignWithLabel:false
              },
              data:[],
              axisLabel:{
                inside:false,  // 横轴图例文字位置（true在bar上）
                textStyle:{
                  color:'#61a8ff'
                }
              },
              axisLine:{
                show:true,
                lineStyle:{
                  color:'#61a8ff',
                  width:1,
                  type:'solid'
                }
              },
            }
          ],
          yAxis:[
            {
              type:'value',
              name:'人数',
              position:'right',
              axisLine:{
                show:true,
                lineStyle:{
                  color:'#68d8fe'
                }
              },
              axisLabel:{
                formatter:'{value} '
              }
            },
            {
              type:'value',
              name:'人数',
              min:0,
              position:'center',
              splitLine:{
                show:false,
              },
              axisLine:{
                show:true,
                lineStyle:{
                  color:'#EE6666'
                }
              },
              axisLabel:{
                formatter:'{value}'
              }
            },
          ],
          series:[]
        },
        
        // 饼图同意配置信息
        pieOption:{
          tooltip:{
            trigger:'item'
          },
          legend:{
            orient:'vertical',
            left:'left',
            top:20,
            textStyle:{
              color:'#61a8ff'
            },
          },
          series:[
            {
              name:'学历统计',
              type:'pie',
              radius:['40%', '75%'],
              center:['50%', '50%'],
              itemStyle:{
                borderRadius:10 // 设置边界半径，使得饼图变成半圆形
              },
              data:[],
              label:{
                formatter:'{b}:{c}',
                position:'top',
                show:true,
              },
              emphasis:{
                itemStyle:{
                  shadowBlur:10,
                  shadowOffsetX:0,
                  shadowColor:'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        },
        // 饼图同意配置信息  运动经历
        pieOptionPlay:{
          tooltip:{
            trigger:'item'
          },
          legend:{
            orient:'vertical',
            left:'left',
            top:20,
            textStyle:{
              color:'#61a8ff'
            },
          },
          series:[
            {
              name:'运动经历统计',
              type:'pie',
              radius:'50%',
              center:['62%', '50%'],
              itemStyle:{
                borderRadius:10 // 设置边界半径，使得饼图变成半圆形
              },
              data:[],
              label:{
                formatter:'{b}:{c}',
                position:'top',
                show:true,
              },
              emphasis:{
                itemStyle:{
                  shadowBlur:10,
                  shadowOffsetX:0,
                  shadowColor:'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        },
        
        chinaMapByBMP:null
      }
    },
    
    filters:{
      level(level){
        if (!level){
          return '--'
        }
        return LevelFilters(level)
      },
    },
    
    async mounted(){
      const that = this;
      this.fullscreenLoading = true;
      // 加载数据
      await that.loadClassInfo();
      await that.loadTutorialAll();
      that.autoChangeSelectCoachIndex();  // 自动切换
      that.draw();
      window.onresize = debounce(function(){
        // 自动调整绘画区域大小
        that.echartsList.forEach(item => {
          item();
        });
        
      }, 100, false);
      this.fullscreenLoading = false;
      
    },
    
    destroyed(){
      clearInterval(this.coachAutoChangeTimer)
      clearInterval(this.coachAutoChangeTimer);
      clearInterval(this.userLoginTimer);
      clearInterval(this.userLoginTimer);
      clearInterval(this.tableTimer);
      if(this.chinaMapByBMP){
        this.$nextTick(() => {
          this.chinaMapByBMP.dispose()
          this.chinaMapByBMP = null
        })
      }
    },
    
    methods:{
      
      // vue-fullscreen 组件
      toggle(){
        this.fullscreen = !this.fullscreen;
      },
      toggleApi(){
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector('.fullscreen-wrapper'), {
          teleport:this.teleport,    // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback:(isFullscreen) => {
            that.fullscreen = isFullscreen
          },
        })
      },
      
      // 手动检测全屏状态
      isFullNow(){
        let isFull = document.fullscreenEnabled || window.fullScreen || window.webkitIsFullScreen || document.msFullscreenEnabled;
        if(isFull === undefined) isFull = false;
        return isFull;
      },
      imgError() {
        this.$set(this.teacherInfo, "profile_picture", this.userImg);
      },
      // 手动切换讲师
      coachChange(){
        this.loadTeacherInfo(this.selectCoachIndex);
        //   coachAutoChangeTimer: null, // 会员协会默认切换
        //   changeTimer: null,
        if(this.coachAutoChangeTimer) clearInterval(this.coachAutoChangeTimer);
        if(this.changeTimer) clearTimeout(this.changeTimer);
        
        this.changeTimer = setTimeout(() => {
          this.autoChangeSelectCoachIndex()
        })
      },
      // 切换显示当前足协显示数据 selectCoachIndex   coachAutoChangeTimer
      autoChangeSelectCoachIndex(){
        if(this.coachAutoChangeTimer) clearInterval(this.coachAutoChangeTimer);
        this.coachAutoChangeTimer = setInterval(() => {
          let idx = Math.floor((Math.random()*this.coachList.length-1)+1);
          this.selectCoachIndex = this.coachList[idx].value;
          this.loadTeacherInfo(this.selectCoachIndex);
        }, 8000)
      },
      
      
      // 绘制教练员成绩分析统计图表
      draw_tutorial_add(){
        const {xAxisData, passSeriesData, failSeriesData, passRateSeriesData} = this.formateCoachData2EchartsData()
        let options = this.doubleYaxisEcharts;
        let xAxisConfig = options['xAxis'][0];
        xAxisConfig.data = xAxisData;
        let series = [
          {
            name:'男',
            type:'bar',
            data:passSeriesData,
            label:{
              show:true,
              position:"top",
              distance:5,
              align:"center",
              verticalAlign:"middle",
            },
          },
          {
            name:'女',
            type:'bar',
            data:failSeriesData,
            label:{
              show:true,
              position:"top",
              distance:5,
              align:"center",
              verticalAlign:"middle",
            },
          },
          {
            name:'共',
            type:'line',
            yAxisIndex:1,
            data:passRateSeriesData,
            label:{
              show:true,
              position:"top",
              distance:5,
              align:"center",
              verticalAlign:"middle",
              formatter:function(val){
                const labels = `${val.value}`
                return labels
              }
            },
          },
        ];
        options = Object.assign({}, options, {xAxis:xAxisConfig, series});
        
        const mapDom = document.getElementById("echart-tutorial-add");
        let tutorial_add = echarts.init(mapDom);
        this.echartsList.push(tutorial_add.resize);
        tutorial_add.setOption(options);
      },
      // 教练员成绩分析原始数据处理
      formateCoachData2EchartsData(){
        const {levelMap, levelMapMen, levelMapWoMen} = this.coachCount;
        let xAxisData = ['职业级', 'A级', 'B级', 'C级', 'D级', 'D级助理'],
          passSeriesData = [], failSeriesData = [], passRateSeriesData = [];
        const passCoachCountMap = levelMapMen;
        const failCoachCountMap = levelMapWoMen;
        const totalCoachCountMap = levelMap;
        
        xAxisData.forEach((item, i) => {
          // 男
          const passItemCount = passCoachCountMap[item] ? passCoachCountMap[item] : 0;
          passSeriesData.push(passItemCount);
          // 女
          const failItemCount = failCoachCountMap[item] ? failCoachCountMap[item] : 0;
          failSeriesData.push(failItemCount);
          // 总
          const passRateItemCount = totalCoachCountMap[item] ? totalCoachCountMap[item] : 0
          passRateSeriesData.push(passRateItemCount)
        });
        
        return {xAxisData, passSeriesData, failSeriesData, passRateSeriesData}
      },
      
      // 绘制会员协会用户总量统计图表
      draw_associate_all(){
        let {xAxis} = this.barEchartOption;
        const {xAxisData, groupRankTypeSeriesData} = this.vipUserCountEchartData;
        let tooltip = {
          trigger:'axis',
          axisPointer:{
            type:'shadow'
          }
        };
        // 设置图例
        let legend = {
          data:['讲师数量'],
          show:true,
          textStyle:{
            color:'#61a8ff'
          },
        };
        // 设置横向坐标
        xAxis = Object.assign({}, xAxis, {data:xAxisData});
        
        let series = [
          {
            name:'讲师数量',
            type:'bar',
            barwidth:'80%',
            data:groupRankTypeSeriesData,
            label:{
              show:true,
              position:'top',
              distance:5,
              align:'center',
              verticalAlign:'middle',
            }
          },
        ];
        let color = [
          '#68d8fe', '#fac858', '#ee6666', '#73c0de'
        ];
        let yAxis = [
          {
            type:'value',
            axisLine:{
              show:true,
              lineStyle:{
                color:'#61a8ff',
                width:1,
                type:'solid'
              }
            },
            nameTextStyle:{
              color:['#FFFFFF']
            }
          }
        ];
        let grid = {
          top:'5%',
          left:'2%',
          height:"78%",
          width:"95%"
        };
        const options = Object.assign({}, this.barEchartOption, {
          tooltip,
          grid,
          xAxis,
          yAxis,
          series,
          color
        });
        const mapDom = document.getElementById("echart-associate-all");
        let associate_all = echarts.init(mapDom);
        this.echartsList.push(associate_all.resize);
        associate_all.setOption(options);
        
      },
      
      // 绘制会员协会培训班统计表
      draw_xueli_status(){
        // 设置图例
        const {series} = this.pieOption;
        const sourceSeries = series[0];
        const {seriesData, title} = this.formateSourceData2PieData();
        sourceSeries.data = seriesData;
        // let titleConfig = {
        //     text: title,
        //     left: 'center',
        //     textStyle: {
        //         // color: '#00f2f1'
        //         color: '#FFFFFF',
        //         fontSize: 15
        //     }
        //
        // };
        let color = [
          '#68d8fe', '#fac858', '#ee6666', '#73c0de', '#156cd9', '#15d926'
        ];
        const options = Object.assign({}, this.pieOption, {
          series:[sourceSeries],
          color
        })
        
        const mapDom = document.getElementById("echart-class-status");
        let class_status = echarts.init(mapDom);
        this.echartsList.push(class_status.resize)
        class_status.setOption(options);
      },
      
      // // 学历饼图pie饼图数据
      formateSourceData2PieData(){
        const {xAxisData, y_Gaozhong, y_Zhizhuan, y_Dazhuan, y_Benke, y_Shuoshi, y_BoShi} = this.vipClassEchartsData;
        const seriesData = [
          {value:y_Gaozhong, name:'高中'},
          {value:y_Zhizhuan, name:'职专'},
          {value:y_Dazhuan, name:'大专'},
          {value:y_Benke, name:'本科'},
          {value:y_Shuoshi, name:'硕士'},
          {value:y_BoShi, name:'博士'}
        ];
        return {seriesData, xAxisData};
      },
      // 绘制会员协会培训班统计表
      draw_play_status(){
        // 设置图例
        const {series} = this.pieOptionPlay;
        const sourceSeries = series[0];
        const {seriesData, title} = this.formatePlay();
        sourceSeries.data = seriesData;
        // let titleConfig = {
        //     text: title,
        //     left: 'center',
        //     textStyle: {
        //         // color: '#00f2f1'
        //         color: '#FFFFFF',
        //         fontSize: 15
        //     }
        //
        // };
        let color = [
          '#d2e6ed', '#68d8fe', '#fac858', '#ee6666', '#73c0de', '#156cd9', '#15d926', '#fe68dc', '#b77090', '#bf643f', '#983ec5', '#d1c68f', '#db3387'
        ];
        const options = Object.assign({}, this.pieOptionPlay, {
          series:[sourceSeries],
          color
        })
        
        const mapDom = document.getElementById("echart-play-status");
        let class_status = echarts.init(mapDom);
        this.echartsList.push(class_status.resize)
        class_status.setOption(options);
      },
      // // 运动经历饼图pie饼图数据
      formatePlay(){
        const {xAxisData, y_None, y_Guojia, y_Dingji, y_Dier, y_Wuren, y_Disan, y_WurenEr, y_Quanguo, y_Difang, y_Jingying, y_Qingshao, y_Xiaoyuan, y_Qita} = this.vipPlayEchartsData;
        const seriesData = [
          {value:y_None, name:'无运动经历'},
          {value:y_Guojia, name:'国家队'},
          {value:y_Dingji, name:'顶级职业联赛'},
          {value:y_Dier, name:'第二级别联赛'},
          {value:y_Wuren, name:'五人制职业联赛'},
          {value:y_Disan, name:'第三级别联赛'},
          {value:y_WurenEr, name:'五人制第二级别联赛'},
          {value:y_Quanguo, name:'全国性业余联赛'},
          {value:y_Difang, name:'地方性业余联赛'},
          {value:y_Jingying, name:'全国性精英青少年比赛'},
          {value:y_Qingshao, name:'地方性青少年比赛'},
          {value:y_Xiaoyuan, name:'校园足球比赛'},
          {value:y_Qita, name:'其他'},
        ];
        return {seriesData, xAxisData};
      },
      // 绘制大屏
      draw(){
        
        // 绘制会员协会培训班统计
        this.draw_xueli_status();
        
        // 绘制新增教案图表
        this.draw_tutorial_add();
        // 绘制运动经历
        this.draw_play_status();
        // 绘制会员协会用户总量统计
        this.draw_associate_all();
        
      },
      
      // 加载培训班相关数据信息
      async loadClassInfo(){
        try{
          const {data} = await getTeachersData();
          if(data.status !== 0){
            this.$message.error(data.msg);
            return
          }
          // 处理培训班统计数据
          this.numStatistical = data.result.levelMap;
          this.numStatisticalG = data.result.levelMapG;
          this.numStatisticalPhysical = data.result.levelMapPhysical;
          this.numStatisticalSex = data.result.sexMap;
          this.$set(this.coachCount, "levelMap", data.result.levelMap);
          this.$set(this.coachCount, "levelMapMen", data.result.levelMapMen);
          this.$set(this.coachCount, "levelMapWoMen", data.result.levelMapWoMen);
          this.userInfoOrganization = data.result.organMap;
          this.formateVipUserData2EchartsLineData();
          this.coachList = data.result.teacherList;
          let idx = Math.floor((Math.random()*this.coachList.length-1)+1);
          this.selectCoachIndex =  this.coachList[idx].value
          this.loadTeacherInfo(this.selectCoachIndex);
        }catch(e){
          console.error(e)
        }
      },
      
      
      // 处理协会培训班数据转化为图表数据
      formateDate2EchartsBarData(sourceData){
        let x_data = Object.keys(sourceData);
        if(!x_data.length){
          this.vipClassEchartsData = {
            xAxisData:[],
            y_Gaozhong:[],
            y_Zhizhuan:[],
            y_Dazhuan:[],
            y_Benke:[],
            y_Shuoshi:[],
            y_BoShi:[],
          };
          return
        }
        let y_Gaozhong = [];
        let y_Zhizhuan = [];
        let y_Dazhuan = [];
        let y_Benke = [];
        let y_Shuoshi = [];
        let y_BoShi = [];
        y_Gaozhong.push(sourceData['高中']);
        y_Zhizhuan.push(sourceData['职专']);
        y_Dazhuan.push(sourceData['大专']);
        y_Benke.push(sourceData['本科']);
        y_Shuoshi.push(sourceData['硕士']);
        y_BoShi.push(sourceData['博士']);
        this.echartsBarX = x_data;
        this.echartsBarYData = {
          y_Gaozhong,
          y_Zhizhuan,
          y_Dazhuan,
          y_Benke,
          y_Shuoshi,
          y_BoShi
        };
        this.vipClassEchartsData = {
          xAxisData:x_data,
          y_Gaozhong,
          y_Zhizhuan,
          y_Dazhuan,
          y_Benke,
          y_Shuoshi,
          y_BoShi
        };
      },
      // 运动经历
      formatePlayBarData(sourceData){
        let x_data = Object.keys(sourceData);
        if(!x_data.length){
          this.vipPlayEchartsData = {
            xAxisData:[],
            y_None:[],
            y_Guojia:[],
            y_Dingji:[],
            y_Dier:[],
            y_Wuren:[],
            y_Disan:[],
            y_WurenEr:[],
            y_Quanguo:[],
            y_Difang:[],
            y_Jingying:[],
            y_Qingshao:[],
            y_Xiaoyuan:[],
            y_Qita:[],
          };
          return
        }
        let y_None = [];
        let y_Guojia = [];
        let y_Dingji = [];
        let y_Dier = [];
        let y_Wuren = [];
        let y_Disan = [];
        let y_WurenEr = [];
        let y_Quanguo = [];
        let y_Difang = [];
        let y_Jingying = [];
        let y_Qingshao = [];
        let y_Xiaoyuan = [];
        let y_Qita = [];
        y_None.push(sourceData['无运动经历']);
        y_Guojia.push(sourceData['国家队']);
        y_Dingji.push(sourceData['顶级职业联赛']);
        y_Dier.push(sourceData['第二级别联赛']);
        y_Wuren.push(sourceData['五人制职业联赛']);
        y_Disan.push(sourceData['第三级别联赛']);
        y_WurenEr.push(sourceData['五人制第二级别联赛']);
        y_Quanguo.push(sourceData['全国性业余联赛']);
        y_Difang.push(sourceData['地方性业余联赛']);
        y_Jingying.push(sourceData['全国性精英青少年比赛']);
        y_Qingshao.push(sourceData['地方性青少年比赛']);
        y_Xiaoyuan.push(sourceData['校园足球比赛']);
        y_Qita.push(sourceData['其他']);
        this.echartsBarX = x_data;
        
        this.echartsBarYData = {
          y_None,
          y_Guojia,
          y_Dingji,
          y_Dier,
          y_Wuren,
          y_Disan,
          y_WurenEr,
          y_Quanguo,
          y_Difang,
          y_Jingying,
          y_Qingshao,
          y_Xiaoyuan,
          y_Qita
        };
        this.vipPlayEchartsData = {
          xAxisData:x_data,
          y_None,
          y_Guojia,
          y_Dingji,
          y_Dier,
          y_Wuren,
          y_Disan,
          y_WurenEr,
          y_Quanguo,
          y_Difang,
          y_Jingying,
          y_Qingshao,
          y_Xiaoyuan,
          y_Qita,
        };
      },
      
      // 加载教案统计
      async loadTutorialAll(){
        try{
          const {data} = await getTeachersVitaeData();
          if(data.status !== 0){
            this.$message.error(data.msg);
            return
          }
          this.classData = data.result.classData
          this.formateDate2EchartsBarData(data.result.xueli)
          this.formatePlayBarData(data.result.playing)
        }catch(e){
          console.error(e)
        }
      },
      async loadTeacherInfo(params){
        let submiteData = {};
        if(params) {
          submiteData = {
            uid: params
          }
        }
        try{
          const {data} = await getTeachersVitaeDataInfo(submiteData);
          if(data.status !== 0){
            this.$message.error(data.msg);
            return
          }
          this.teacherInfo=data.result.resultMap
        }catch(e){
          console.error(e)
        }
      },
      
      // 会员协会用户总量统计数据转化
      formateVipUserData2EchartsLineData(){
        let xAxisData = [], groupRankTypeSeriesData = [], coachListTmp = [],
          coachList = [];
        coachList = this.userInfoOrganization;
        for(let key in coachList){
          let value = coachList[key];
          xAxisData.push(key);
          groupRankTypeSeriesData.push(value);
        }
        this.vipUserCountEchartData = {xAxisData, groupRankTypeSeriesData};
      },
      
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .display-wrapper
    width 100%
    height 100%
    background-color #101129 !important
  
  .display-content
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    /*min-height 780px*/
    margin 0 auto
    display flex
    padding 6rem 0.8rem 0
    background url("../../assets/images/display/logo_teacher.png") no-repeat 0 0 / contain;
    
    .column
      position relative
      flex 3.33333
      
      .row
        box-sizing border-box
        border 2px solid red
        border-image url("../../assets/images/display/border.png") 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 2rem
        color #FFFFFF
      
      .row-content
        position:absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem
      
      .class-all
        height 150px
        
        .row-title
          color #68D8FE
          font-weight 600
          font-size 16px
          display flex
          align-items center
          
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 1rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          
          .btn-active
            background-color #0BACE6
            color #FFFFFF
        
        .data-wrapper
          display flex
          flex-wrap wrap
          
          .data-item
            flex 1
            font-size 12px
            text-align center
            
            .data
              font-size 26px
            .num_data
              font-size 20px !important
              margin-top 10px
            
            .data-title
              color #4C9BFD
              margin-top 5px
      
      .class-table
        height 350px
        
        .row-content
          padding 1.25rem 0
        
        .nav-title-wrapper
          padding-left 1.25rem
          margin-bottom 0.8rem
          
          .nav-item
            margin-right 15px
            cursor pointer
            color #1950C4
            padding-right 15px
            border-right 2px solid #00F2F1
            &:last-child
              border-right none
          
          .active-title
            color #FFFFFF
        
        .table-wrapper
          .table-head
            display flex
            width 100%
            background-color rgba(255, 255, 255, 0.1)
            color #68D8FE
            padding 0 1rem
            line-height 3rem
            
            .table-column
              /*flex 1*/
              text-align center
              
              &:nth-child(1)
                width 20%
              
              &:nth-child(2)
                width 30%
              
              &:nth-child(3)
                width 20%
              
              &:nth-child(4)
                width 15%
              
              &:nth-child(5)
                width 15%
          
          .table-content
            height 225px
            overflow hidden
            
            .table-row
              width 100%
              display flex
              padding 0 1rem
              line-height 2.5rem
              color #61A8FF
              
              &:hover
                background-color rgba(255, 255, 255, 0.1)
                color #68D8FE
              
              .table-col
                overflow hidden
                overflow-wrap break-word
                text-align center
                
                &:nth-child(1)
                  width 20%
                
                &:nth-child(2)
                  width 30%
                
                &:nth-child(3)
                  width 20%
                
                &:nth-child(4)
                  width 15%
                
                &:nth-child(5)
                  width 15%
    
    .center
      flex 4
      margin 5.8rem 1.5rem 0
      
      .map-title
        color #68D8FE
        font-size 1.6rem
        text-align center
      
      .echart-map
        width 100%
        /*height 440px + 4.875rem*/
        height 455px
      .online
        position absolute
        top -18px
        left 0
        z-index 999
        .online-content
          width inherit
          height inherit
          position absolute
          top -40px
          left -56px
          display flex
          flex-direction column
          .title
            width 100%
            color:#68D8FE
            font-size 1.6rem
            line-height 4rem
            text-align center
          .content
            flex 1
            font-size 2.4rem
            display flex
            justify-content center
            align-items center
  
  .table-content
    .animation-wrapper
      animation row 40s linear infinite
      
      &:hover
        animation-play-state paused
  
  .tutorial-add
    height 300px !important
    
    .data-wrapper
      height 90%
    
    .echart-tutorial-add
      width 100%
      height 100%
  
  .login-data
    height 340px !important
    
    .data-wrapper
      height 90%
    
    .echart-user-login
      width 100%
      height 100%
  
  .class-vip
    height 240px !important
    
    .data-wrapper
      height 90%
    
    .echart-class-status
      width 100%
      height 100%
  
  .play-vip
    height 400px !important
    
    .data-wrapper
      height 90%
    
    .echart-class-status
      width 100%
      height 100%
  
  .user-all
    height 400px !important
    /*margin-top 4.6rem*/
    
    .flex-box
      display flex
      width 100%
      height 100%
      
      .flex-item
        /*flex 1 1*/
        height 100%
        
        .data-wrapper
          height 90%
      
      .left
        flex 5
      
      .right
        flex 2
        padding 8rem 2rem 8rem 2rem
        display flex
        flex-direction column
        justify-content space-around
        font-size 1.4rem
        color #61A8FF
        text-align center
        
        .line-text
          /*text-align left*/
          display flex
          justify-content space-between
          
          span:nth-child(1)
            display flex
            align-items center
            justify-content flex-start
          
          span:nth-child(2)
            font-size 2.5rem
            margin-left 5px
            color:#FFFFFF
            text-align left
            display block
            width 6rem
    
    .echart-associate-all
      width 100%
      height 100%
  
  @keyframes row{
    0%{
    }
    100%{
      transform translateY(-50%)
    }
  }
  
  .fullscreen-btn
    color #61A8FF
    cursor pointer
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0B93D5
      color #68D8FE
  
  /*.el-select-dropdown*/
  /*    background-color #101129 !important*/
  /*    color #FFFFFF !important*/
  /*.el-select-dropdown__item.hover, .el-select-dropdown__item:hover*/
  /*    background-color #101129 !important*/
  /*    color #FFFFFF !important*/
</style>

